export function createPlayerManager({
  playerSelector = '.js-player',
  defaultParentSelector = '.js-overlay-ancestor',
} = {}) {
  const player = document.querySelector(playerSelector);
  const defaultParent = document.querySelector(defaultParentSelector);

  let originalParent = null;
  let originalNextSibling = null;

  function ensureOriginalSaved() {
    if (!player) return;
    if (!originalParent) {
      originalParent = player.parentNode;
      originalNextSibling = player.nextSibling;
    }
  }

  return {
    get player() {
      return player;
    },

    moveInto(container) {
      if (!player || !container) return;
      ensureOriginalSaved();
      if (container.contains(player)) return;
      container.appendChild(player);
    },

    restore() {
      if (!player) return;

      if (originalParent) {
        if (originalNextSibling) {
          originalParent.insertBefore(player, originalNextSibling);
        } else {
          originalParent.appendChild(player);
        }
        return;
      }

      if (defaultParent && !defaultParent.contains(player)) {
        defaultParent.appendChild(player);
      }
    },
  };
}

